export default {"src":"/_next/static/media/sticker-5.b7c1d843.svg","height":105,"width":104,"blurWidth":0,"blurHeight":0};